export const ACTIVE_POLICY_EFFECTIVE_TO_ERROR_MESSAGE =
    'When Active Policy is selected, Effective To cannot be earlier than today';

export const VOB_SAVE_VALIDATION_ISSUES_PREFIX = 'Please resolve the following issues: ';

export function buildActivePolicyEffectiveToSaveBannerMessage(): string {
    return `${VOB_SAVE_VALIDATION_ISSUES_PREFIX}${ACTIVE_POLICY_EFFECTIVE_TO_ERROR_MESSAGE}; `;
}

export function isActivePolicyEffectiveToBeforeToday(
    activePolicy: boolean,
    effectiveToDate: Date | null
): boolean {
    if (!activePolicy || !effectiveToDate) return false;
    const effectiveToDay = new Date(effectiveToDate);
    effectiveToDay.setHours(0, 0, 0, 0);
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    return effectiveToDay < todayStart;
}
